/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

const styles = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "16px"
  },
  modalBox: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    width: "100%",
    maxWidth: "880px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    padding: "20px",
    paddingBottom: "max(20px, env(safe-area-inset-bottom))",
    position: "relative"
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px"
  },
  modalTitle: {
    margin: 0,
    fontSize: "1.4rem",
    lineHeight: 1.2
  },
  modalActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexWrap: "wrap",
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    backgroundColor: "#fff",
    gap: "10px",
    marginTop: "20px",
    paddingTop: "20px",
    paddingBottom: "max(8px, env(safe-area-inset-bottom))",
    borderTop: "1px solid #eee"
  },
  statusMessage: {
    marginRight: "auto",
    fontSize: "14px"
  },
  statusError: {
    color: "red"
  },
  statusSuccess: {
    color: "green"
  },
  actionButton: {
    minWidth: "120px"
  },
  formField: {
    marginBottom: "20px"
  },
  scaleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px"
  },
  scaleLabel: {
    fontSize: "12px",
    color: "#666"
  },
  configNotice: {
    marginBottom: "14px",
    padding: "10px 12px",
    borderRadius: "8px",
    background: "#f6f8fb",
    color: "#516173",
    fontSize: "13px"
  },
  "@media (max-width: 600px)": {
    modal: {
      alignItems: "flex-start",
      padding: "8px"
    },
    modalBox: {
      marginTop: "8px",
      maxHeight: "calc(100vh - 76px)",
      padding: "14px"
    },
    modalHeader: {
      alignItems: "flex-start",
      flexDirection: "column"
    },
    modalTitle: {
      fontSize: "1.15rem"
    },
    modalActions: {
      flexDirection: "column",
      alignItems: "stretch",
      marginTop: "12px",
      paddingTop: "12px"
    },
    actionButton: {
      width: "100%",
      marginLeft: "0 !important"
    },
    statusMessage: {
      marginRight: 0,
      marginBottom: "8px"
    }
  },
  "@supports (-webkit-touch-callout: none)": {
    modalBox: {
      maxHeight: "calc(100vh - 76px)"
    }
  }
};

class TrainingNote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        title: "",
        activity: "",
        notes: "",
        date: new Date().toISOString().split("T")[0],
        answers: {}
      }
    };
  }

  componentDidMount() {
    const {
      selectedNote,
      viewMode,
      addActivity,
      trainingName,
      trainingDescription,
      trainingDate
    } = this.props;
    if (selectedNote && (viewMode === "view" || viewMode === "edit")) {
      this.setState({
        formData: {
          title: selectedNote.title || "",
          activity: selectedNote.activity || "",
          notes: selectedNote.notes || "",
          date:
            selectedNote.date ||
            (selectedNote.created_at &&
              selectedNote.created_at.split("T")[0]) ||
            "",
          answers: selectedNote.answers || {}
        }
      });
    } else if (addActivity && viewMode === "create") {
      this.setState({
        formData: {
          title: trainingName || "",
          activity: "",
          activityName: trainingName || "",
          notes: trainingDescription || "",
          date: trainingDate || new Date().toISOString().split("T")[0],
          answers: {}
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      selectedNote,
      viewMode,
      addActivity,
      trainingName,
      trainingDescription,
      trainingDate
    } = this.props;
    if (
      prevProps.selectedNote !== selectedNote ||
      prevProps.viewMode !== viewMode ||
      prevProps.addActivity !== addActivity ||
      prevProps.trainingName !== trainingName ||
      prevProps.trainingDescription !== trainingDescription ||
      prevProps.trainingDate !== trainingDate
    ) {
      if (selectedNote && (viewMode === "view" || viewMode === "edit")) {
        this.setState({
          formData: {
            title: selectedNote.title || "",
            activity: selectedNote.activity || "",
            notes: selectedNote.notes || "",
            date:
              selectedNote.date ||
              (selectedNote.created_at &&
                selectedNote.created_at.split("T")[0]) ||
              "",
            answers: selectedNote.answers || {}
          }
        });
      } else if (addActivity && viewMode === "create") {
        this.setState({
          formData: {
            title: trainingName || "",
            activity: "",
            activityName: trainingName || "",
            notes: trainingDescription || "",
            date: trainingDate || new Date().toISOString().split("T")[0],
            answers: {}
          }
        });
      } else if (viewMode === "create" && !addActivity) {
        this.setState({
          formData: {
            title: "",
            activity: "",
            notes: "",
            date: new Date().toISOString().split("T")[0],
            answers: {}
          }
        });
      }
    }
  }

  handleInputChange = (field, value) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [field]: value
        }
      },
      () => {
        // Notify parent of form data changes
        if (this.props.onFormDataChange) {
          this.props.onFormDataChange(this.state.formData);
        }
      }
    );
  };

  setFormFields = (field1, value1, field2, value2) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [field1]: value1,
          [field2]: value2
        }
      },
      () => {
        if (this.props.onFormDataChange) {
          this.props.onFormDataChange(this.state.formData);
        }
      }
    );
  };

  handleAnswerChange = (questionKey, value) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          answers: {
            ...this.state.formData.answers,
            [questionKey]: value
          }
        }
      },
      () => {
        if (this.props.onFormDataChange) {
          this.props.onFormDataChange(this.state.formData);
        }
      }
    );
  };

  renderQuestionInput = question => {
    const { classes } = this.props;
    const { formData } = this.state;

    if (question.type === "scale") {
      return (
        <div className={classes.formField} key={question.key}>
          <InputLabel>{question.label}</InputLabel>
          <div className={classes.scaleContainer}>
            <span className={classes.scaleLabel}>
              {question.scale.labels[question.scale.min]}
            </span>
            <RadioGroup
              row
              value={formData.answers[question.key] || ""}
              onChange={e =>
                this.handleAnswerChange(question.key, e.target.value)
              }
            >
              {Array.from(
                { length: question.scale.max - question.scale.min + 1 },
                (_, i) => {
                  const value = question.scale.min + i;
                  return (
                    <FormControlLabel
                      key={value}
                      value={value.toString()}
                      control={<Radio />}
                      label={value.toString()}
                    />
                  );
                }
              )}
            </RadioGroup>
            <span className={classes.scaleLabel}>
              {question.scale.labels[question.scale.max]}
            </span>
          </div>
        </div>
      );
    }

    if (question.type === "select") {
      return (
        <FormControl fullWidth className={classes.formField} key={question.key}>
          <InputLabel>{question.label}</InputLabel>
          <Select
            value={formData.answers[question.key] || ""}
            onChange={e =>
              this.handleAnswerChange(question.key, e.target.value)
            }
          >
            {question.options.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return null;
  };

  render() {
    const {
      classes,
      open,
      onClose,
      viewMode,
      selectedNote,
      onToggleEditMode,
      onSave,
      saving,
      saveError,
      saveMessage,
      config,
      addActivity
    } = this.props;
    const { formData } = this.state;

    return (
      <Modal
        open={open}
        onClose={null}
        className={classes.modal}
        aria-labelledby="training-note-modal"
        aria-describedby="modal-for-training-note"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <Box className={classes.modalBox}>
          <div className={classes.modalHeader}>
            <h2 className={classes.modalTitle}>
              {addActivity && viewMode === "create"
                ? "Add Activity"
                : viewMode === "create"
                  ? "Add Training Note"
                  : viewMode === "edit"
                    ? "Edit Training Note"
                    : "Training Note Details"}
            </h2>
            {(viewMode === "view" || viewMode === "edit") &&
              selectedNote && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={viewMode === "edit"}
                      onChange={onToggleEditMode}
                      color="primary"
                    />
                  }
                  label="Edit Mode"
                />
              )}
          </div>

          {viewMode === "view" && selectedNote ? (
            <div>
              <div className={classes.formField}>
                <strong>Title:</strong> {selectedNote.title}
              </div>
              <div className={classes.formField}>
                <strong>Date:</strong>{" "}
                {selectedNote.date ||
                  (selectedNote.created_at &&
                    selectedNote.created_at.split("T")[0]) ||
                  "-"}
              </div>
              <div className={classes.formField}>
                <strong>Activity Id:</strong> {selectedNote.activity || "-"}
              </div>
              {selectedNote.metadata &&
                selectedNote.metadata.answers &&
                Object.keys(selectedNote.answers).length > 0 && (
                  <div className={classes.formField}>
                    <strong>Responses:</strong>
                    <div style={{ marginTop: "10px" }}>
                      {Object.entries(selectedNote.answers).map(
                        ([key, value]) => (
                          <div key={key} style={{ marginBottom: "5px" }}>
                            <em>{key}:</em> {value}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              <div className={classes.formField}>
                <strong>Notes:</strong>
                <div style={{ marginTop: "10px", whiteSpace: "pre-wrap" }}>
                  {selectedNote.notes ||
                    selectedNote.content ||
                    "No additional notes"}
                </div>
              </div>
            </div>
          ) : (
            <div>
              {!config && (
                <div className={classes.configNotice}>
                  Loading activity options. You can still enter title, date and
                  notes while this loads.
                </div>
              )}
              <div>
                {addActivity ? (
                  <CustomInput
                    labelText={`Activity Name ${
                      viewMode === "create" || viewMode === "edit" ? "*" : ""
                    }`}
                    id="activity-name"
                    formControlProps={{
                      fullWidth: true,
                      className: classes.formField
                    }}
                    inputProps={{
                      value: this.props.trainingName || "",
                      disabled: viewMode === "view" || addActivity,
                      onChange: e =>
                        this.handleInputChange("activityName", e.target.value)
                    }}
                  />
                ) : (
                  <FormControl
                    fullWidth
                    className={classes.formField}
                    disabled={viewMode === "view" || !config}
                  >
                    <InputLabel>
                      Activity{" "}
                      {(viewMode === "create" || viewMode === "edit") && "*"}
                    </InputLabel>
                    <Select
                      value={formData.activity}
                      onChange={e => {
                        if (!config || !config.recent_activities) {
                          return;
                        }
                        const activityId = e.target.value;
                        const selectedActivity = config.recent_activities.find(
                          activity => activity.id === activityId
                        );
                        const activityDate =
                          selectedActivity && selectedActivity.time
                            ? new Date(selectedActivity.time)
                                .toISOString()
                                .split("T")[0]
                            : formData.date;

                        if (formData.title.length === 0) {
                          if (selectedActivity) {
                            this.setState(
                              {
                                formData: {
                                  ...this.state.formData,
                                  activity: activityId,
                                  title: `${selectedActivity.name} - ${new Date(
                                    selectedActivity.time
                                  ).toLocaleDateString()}`,
                                  date: activityDate
                                }
                              },
                              () => {
                                if (this.props.onFormDataChange) {
                                  this.props.onFormDataChange(
                                    this.state.formData
                                  );
                                }
                              }
                            );
                          }
                        } else {
                          this.setState(
                            {
                              formData: {
                                ...this.state.formData,
                                activity: activityId,
                                date: activityDate
                              }
                            },
                            () => {
                              if (this.props.onFormDataChange) {
                                this.props.onFormDataChange(
                                  this.state.formData
                                );
                              }
                            }
                          );
                        }
                      }}
                    >
                      {config &&
                        config.recent_activities &&
                        config.recent_activities.map(activity => (
                          <MenuItem key={activity.id} value={activity.id}>
                            {activity.name} -{" "}
                            {new Date(activity.time).toLocaleString("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              weekday: "short",
                              hour: "2-digit",
                              minute: "2-digit"
                            })}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}

                <CustomInput
                  labelText={`Title ${
                    viewMode === "create" || viewMode === "edit" ? "*" : ""
                  }`}
                  id="title"
                  formControlProps={{
                    fullWidth: true,
                    className: classes.formField
                  }}
                  inputProps={{
                    value: formData.title,
                    disabled: viewMode === "view",
                    onChange: e =>
                      this.handleInputChange("title", e.target.value),
                    maxLength:
                      config && config.fields && config.fields.title
                        ? config.fields.title.max_length
                        : 255
                  }}
                />

                <TextField
                  label={`Date ${
                    viewMode === "create" || viewMode === "edit" ? "*" : ""
                  }`}
                  type="date"
                  fullWidth
                  disabled={viewMode === "view"}
                  className={classes.formField}
                  value={formData.date}
                  onChange={e => this.handleInputChange("date", e.target.value)}
                  InputLabelProps={{
                    shrink: true
                  }}
                />

                {config &&
                  config.questions &&
                  config.questions.map(question =>
                    this.renderQuestionInput(question)
                  )}

                <TextField
                  label="Notes"
                  multiline
                  rows={4}
                  fullWidth
                  disabled={viewMode === "view"}
                  className={classes.formField}
                  value={formData.notes}
                  onChange={e =>
                    this.handleInputChange("notes", e.target.value)
                  }
                />
              </div>
            </div>
          )}

          <div className={classes.modalActions}>
            {saveError && (
              <div
                className={`${classes.statusMessage} ${classes.statusError}`}
              >
                {saveError}
              </div>
            )}
            {saveMessage && (
              <div
                className={`${classes.statusMessage} ${classes.statusSuccess}`}
              >
                {saveMessage}
              </div>
            )}
            <Button
              color="default"
              onClick={onClose}
              className={classes.actionButton}
            >
              {viewMode === "view" ? "Close" : "Cancel"}
            </Button>
            {(viewMode === "create" || viewMode === "edit") && (
              <Button
                color="info"
                className={classes.actionButton}
                onClick={() => onSave(formData)}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save"}
              </Button>
            )}
          </div>
        </Box>
      </Modal>
    );
  }
}

TrainingNote.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  viewMode: PropTypes.oneOf(["create", "view", "edit"]).isRequired,
  selectedNote: PropTypes.object,
  onToggleEditMode: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onFormDataChange: PropTypes.func,
  saving: PropTypes.bool,
  saveError: PropTypes.string,
  saveMessage: PropTypes.string,
  config: PropTypes.object,
  addActivity: PropTypes.bool,
  trainingName: PropTypes.string,
  trainingDescription: PropTypes.string,
  trainingDate: PropTypes.string
};

TrainingNote.defaultProps = {
  saving: false,
  saveError: "",
  saveMessage: "",
  selectedNote: null,
  config: null,
  addActivity: false,
  trainingName: "",
  trainingDescription: "",
  trainingDate: "",
  onToggleEditMode: () => {},
  onFormDataChange: () => {}
};

export default withStyles(styles)(TrainingNote);
